import { css } from '@emotion/react'

export const tabs = css`
  margin-top: 0;
  margin-bottom: 24px;
`
